
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { Options, prop, Vue } from "vue-class-component";
class Props {
  approvalType = prop<string>({
    type: String,
    default: "", //renewal|current|period
  });
  id = prop<number>({
    type: Number,
    default: 0, //renewal id atau client id
  });
  clientName = prop<string>({
    type: String,
    default: "",
  });
  clientType = prop<string>({
    type: String,
    default: "", // Induk atau Cabang
  });
  errorMessage = prop<string>({
    type: String,
    default: "", // error message
  });
}
@Options({
  emits: ["onGetDetail"],
  components: {},
})
export default class ConfirmationApprovalRejectClient extends Vue.with(Props) {
  get isPeriod() {
    return this.approvalType === "period"
  }

  get rejectWordings(): { title: string, message: string } {
    if(this.isPeriod) {
      return {
        title: this.$t('clientManagement.approval.rejectClientPeriodPriceSubmission').toString(),
        message: this.$t('clientManagement.approval.rejectClientPeriodPriceSubmissionSelect').toString(),
      }
    }

    return {
      title: this.$t('clientManagement.approval.rejectClientSubmissionQuestion', { clientType: this.clientType.toLowerCase() }).toString(),
      message: this.$t('clientManagement.approval.selectRejectReasonForFixingSubmission').toString(),
    }
  }

  openRejectConfirmation() {
    this.rejectConfirmation = true;
  }
  openApprovalConfirmation() {
    if(this.isPeriod) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "badge-confirmation-general",
          title: this.$t("clientManagement.approval.acceptClientPeriodSubmissionQuestion").toString(),
          message: this.$t("clientManagement.approval.acceptClientPeriodSubmissionQuestionDesc").toString(),
          textCancel: this.$t("clientManagement.infoPriceClient.back").toString(),
          textSuccess: this.$t("clientManagement.approval.yesAccept").toString(),
          onClose: () => {
            MainAppController.closeMessageModal();
          },
          onSubmit: () => {
            this.onSubmitApproval();
          },
        })
      );
    } else {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "badge-confirmation-general",
          title: this.$t("clientManagement.approval.acceptClientSubmissionQuestion", { clientType: this.clientType.toLowerCase() }).toString(),
          message:
            this.clientType.toLowerCase() === "induk"
              ? this.$t("clientManagement.approval.ensureClientAndPriceDataCorrect").toString()
              : this.$t("clientManagement.approval.ensureClientDetailCorrectBeforeApproval").toString(),
          textCancel: this.$t("clientManagement.infoPriceClient.back").toString(),
          textSuccess: this.$t("clientManagement.approval.yesAccept").toString(),
          onClose: () => {
            MainAppController.closeMessageModal();
          },
          onSubmit: () => {
            this.onSubmitApproval();
          },
        })
      );
    }

  }

  rejectConfirmation = false;

  messageSuccess = "";
  titleSuccess = "";
  openSelect = false;

  get rejectedReasons() {
    return [
      {
        name: this.$t("clientManagement.approval.selectRejectReason").toString(),
        value: "",
      },
      {
        name: this.$t("clientManagement.approval.discountNotApproved").toString(),
        value: this.$t("clientManagement.approval.discountNotApproved").toString(),
      },
      {
        name: this.$t("clientManagement.approval.customRatesNotApproved").toString(),
        value: this.$t("clientManagement.approval.customRatesNotApproved").toString(),
      },
      {
        name: this.$t("clientManagement.approval.discountAndCustomRateNotApproved").toString(),
        value: this.$t("clientManagement.approval.discountAndCustomRateNotApproved").toString(),
      },
      {
        name: this.$t("clientManagement.approval.insuranceRejected").toString(),
        value: this.$t("clientManagement.approval.insuranceRejected").toString(),
      }
    ];
  }
  selectedReason = "";

  async onSubmitApproval() {
    let resp = false;
    MainAppController.closeMessageModal();
    if (this.approvalType === "renewal" || this.isPeriod) {
      resp = await ClientManagementController.approveRenewRates({
        id: this.id,
      });
      this.$emit("success-approve");
    } else {
      await ClientRegistrationController.approveClientRegistration({
        id: this.id,
      });
      this.$emit("success-approve");
    }
    if (resp) {
      this.onShowSnackbarSuccess();
      this.$emit("onGetDetail"); // please call get detail
    }
  }

  onShowSnackbarSuccess() {
    if (this.approvalType === "renewal") {
      MainAppController.setSnackbarMessage(
        this.$t("clientManagement.approval.renewalApprovalSuccess", {
          clientType: this.clientType.toLowerCase(),
          clientName: this.clientName,
        }).toString()
      );
    } else if(this.isPeriod) {
      MainAppController.setSnackbarMessage(this.$t("clientManagement.approval.clientPeriodPriceSubmissionSuccess").toString());
    } else {
      MainAppController.setSnackbarMessage(
        this.$t("clientManagement.approval.clientRequestApprovalSuccess", {
          clientType: this.clientType.toLowerCase(),
          clientName: this.clientName,
        }).toString()
      );
    }
    MainAppController.setSnackbarPositivity(true);
    MainAppController.setSnackbar(true);
  }

  async onRejected() {
    let resp = false;
    MainAppController.closeMessageModal();
    this.rejectConfirmation = false;
    if (this.approvalType === "renewal" || this.isPeriod) {
      resp = await ClientManagementController.rejectRenewRates({
        id: this.id,
        rejectReason: this.selectedReason,
      });
      this.$emit("success-reject");
    } else {
      await ClientRegistrationController.rejectClientRegistration({
        id: this.id,
        rejectReason: this.selectedReason,
      }).then(this.onShowSnackbarError);
      this.$emit("success-reject");
    }
    if (resp) {
      this.onShowSnackbarError();
    }
  }

  onShowSnackbarError() {
    MainAppController.setSnackbar(false);
    if (this.approvalType === "renewal") {
      MainAppController.setSnackbarMessage(
        this.$t("clientManagement.approval.renewalRejectionSuccess", {
          clientType: this.clientType.toLowerCase(),
          clientName: this.clientName,
        }).toString()
      );
    } else if(this.isPeriod) {
      MainAppController.setSnackbarMessage(this.$t("clientManagement.approval.clientPeriodPriceSubmissionRejected").toString());
    } else {
      MainAppController.setSnackbarMessage(
        this.$t("clientManagement.approval.clientRequestRejectionSuccess", {
          clientType: this.clientType.toLowerCase(),
          clientName: this.clientName,
        }).toString()
      );
    }
    MainAppController.setSnackbarTimeout(4000);
    MainAppController.setSnackbarPositivity(false);
    MainAppController.setSnackbar(true);
  }

  closeRejectConfirmation() {
    this.rejectConfirmation = false;
    this.selectedReason = "";
  }

  onSelectReason(_: string, val: string) {
    this.selectedReason = val;
    this.openSelect = false;
  }

  get isDisableReject() {
    return this.selectedReason === "";
  }
}
